/**
 * Fait : le bloc « Mes dépenses » — ce que je peux dépenser et ce que j'ai
 *   déjà dépensé. C'est le SEUL bloc de l'écran de l'argent que tout le monde
 *   voit : un membre ordinaire n'a que celui-là, un parent administrateur le
 *   retrouve derrière son premier onglet.
 *
 *   IL VIT DANS SON PROPRE FICHIER pour n'exister qu'une fois. Recopié aux
 *   deux endroits, il aurait fini par diverger — et c'est la vue du membre,
 *   la moins souvent regardée, qui serait restée en arrière.
 *
 * Ne fait pas : il ne lit rien lui-même et n'écrit nulle part. Il reçoit des
 *   chiffres déjà lus, et se contente de les encadrer.
 */

import { Partie } from '../gabarits/Partie.tsx';
import type { BudgetsVus } from './api-argent.ts';
import { EtatDeMonBudget } from './EtatDeMonBudget.tsx';

export function PartieDeMonBudget({ budgets }: { readonly budgets: BudgetsVus }) {
  return (
    <Partie
      etiquette="Argent"
      titre="Mes dépenses"
      nature="projet"
      niveauDeTitre={2}
      aide="Ce que vous pouvez dépenser, et ce que vous avez déjà dépensé."
      data-role="partie-mon-budget"
    >
      <EtatDeMonBudget budgets={budgets} />
    </Partie>
  );
}
